import { useQuery } from "@apollo/client";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { getFilterItems, getTagFilterItems } from "./sidebar.graphql";
import { useSidebarContext, ACTIONS } from "./context";

const useSidebarDataQuery = (filters, shouldGetFilters) => {
  const { peopleTagTypesFilter } = useWorkspaceFeatureFlags();

  const [
    {
      query: { isLoaded, variables },
    },
    dispatch,
  ] = useSidebarContext();

  const { searchTermsKey } = variables;
  const isSearching = isLoaded && !!searchTermsKey;
  const isSearchingPersonTags = searchTermsKey === "personTags";

  const { personTags, personTagTypes, ...otherFilters } = filters;

  useQuery(getFilterItems, {
    variables: {
      ...variables,
      filter: otherFilters,
    },
    fetchPolicy: "cache-first",
    onCompleted: (data) => {
      dispatch({
        type: ACTIONS.QUERY_COMPLETE,
        data,
      });
    },
    onError: (error) => {
      dispatch({ type: ACTIONS.QUERY_ERROR, error });
    },
    skip: !shouldGetFilters || (isSearching && isSearchingPersonTags),
  });

  useQuery(getTagFilterItems, {
    variables: {
      ...variables,
      filter: { personTags, personTagTypes },
    },
    fetchPolicy: "cache-first",
    onCompleted: (data) => {
      dispatch({
        type: ACTIONS.TAGS_QUERY_COMPLETE,
        data,
      });
    },
    onError: (error) => {
      dispatch({ type: ACTIONS.QUERY_ERROR, error });
    },
    skip:
      !peopleTagTypesFilter ||
      !shouldGetFilters ||
      (isSearching && !isSearchingPersonTags),
  });

  return null;
};

export default useSidebarDataQuery;
